var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27106 8.63883L1.22123 9.67725L0.194098 8.63883L1.22123 7.60042L2.27106 8.63883ZM24.4206 19.0889C24.4206 19.9044 23.7595 20.5655 22.944 20.5655C22.1284 20.5655 21.4673 19.9044 21.4673 19.0889L24.4206 19.0889ZM7.68151 16.2085L1.22123 9.67725L3.32089 7.60042L9.78117 14.1317L7.68151 16.2085ZM1.22123 7.60042L7.68151 1.06914L9.78117 3.14598L3.32089 9.67725L1.22123 7.60042ZM2.27106 7.1622L18.5141 7.1622L18.5141 10.1155L2.27106 10.1155L2.27106 7.1622ZM24.4206 13.0687L24.4206 19.0889L21.4673 19.0889L21.4673 13.0687L24.4206 13.0687ZM18.5141 7.1622C21.7761 7.1622 24.4206 9.80665 24.4206 13.0687L21.4673 13.0687C21.4673 11.4377 20.1451 10.1155 18.5141 10.1155L18.5141 7.1622Z",
    fill: "#304A38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.ccbcd6a2e7587978bc0212e1d2b54940.svg";
export { ForwardRef as ReactComponent };